import React, { Component } from "react";
import { registerForLocalization, provideLocalizationService } from "@progress/kendo-react-intl";
import LoadingPanel from "../../common/LoadingPanel";
import { Grid, GridColumn } from "@progress/kendo-react-grid";

class ZoznamArtiklovVBaliku extends Component {
    state = {
        items: [],
        loading: true,
        selectedArtikel: null,
        title: null
    };

    shouldComponentUpdate(nextProps) {
        if (this.props.selectedBalikId !== nextProps.selectedBalikId) {
            this.props.changeSelectedArtikel(
                nextProps.items[0] != null ? nextProps.items[0].idVariant : null,
                nextProps.items[0] != null ? nextProps.items[0].nazev : null
            );
            const itemId = nextProps.items[0] != null ? nextProps.items[0].id : null;
            this.setState({
                items: nextProps.items,
                selectedArtikel: itemId,
                title: nextProps.title
            });
            return false;
        }
        return true;
    }

    componentDidMount() {
        this.setState({ loading: false });
    }

    renderTable(state) {
        var localizationService = provideLocalizationService(this);
        const { items } = state;
        return (
            <div id="ZoznamArtiklovVBaliku">
                <Grid
                    data={items.map(item => ({ ...item, selected: item.id === state.selectedArtikel }))}
                    total={items ? items.length : 0}
                    pageSize={items ? items.length : 0}
                    pageable={{ buttonCount: 0, info: true, pageSizes: false, previousNext: false }}
                    selectedField="selected"
                    onRowClick={e => {
                        this.props.changeSelectedArtikel(e.dataItem.idVariant, e.dataItem.nazev);
                        this.setState({
                            selectedArtikel: e.dataItem.id
                        });
                    }}>
                    <GridColumn field="nazev" title={state.title} />
                    <GridColumn field="stavString" title={localizationService.toLanguageString("PríjemPodrobne.Stav", "Stav")} width={"100px"} />
                </Grid>
            </div>
        );
    }

    render() {
        let contents = this.state.loading ? <LoadingPanel /> : this.renderTable(this.state);

        return <div>{contents}</div>;
    }
}

export default ZoznamArtiklovVBaliku;

registerForLocalization(ZoznamArtiklovVBaliku);



// WEBPACK FOOTER //
// ./src/components/dialogs/PrijomDodavok/ZoznamArtiklovVBaliku.js